import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GitBranch } from "lucide-react";
import api from "../../lib/api";
import { PageHeader, Card, Empty } from "../../components/crm/ui";
import { toast } from "sonner";

export default function Pipelines() {
  const [pipeline, setPipeline] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [drag, setDrag] = useState(null);

  const load = async () => {
    const { data } = await api.get("/pipelines");
    const p = data.items[0];
    setPipeline(p);
    const { data: cs } = await api.get("/contacts", { params: { page_size: 200 } });
    setContacts(cs.items);
  };
  useEffect(() => { load(); }, []);

  const onDrop = async (stageName) => {
    if (!drag) return;
    const c = drag;
    setDrag(null);
    if (c.stage === stageName) return;
    setContacts((prev) => prev.map((x) => x.id === c.id ? { ...x, stage: stageName } : x));
    try { await api.patch(`/contacts/${c.id}`, { stage: stageName }); toast.success(`Moved to ${stageName}`); }
    catch { toast.error("Move failed"); load(); }
  };

  if (!pipeline) return <div className="text-slate-400 text-sm">Loading…</div>;
  const stages = pipeline.stages || [];

  return (
    <div>
      <PageHeader title="Pipelines" subtitle={pipeline.name} />
      {contacts.length === 0 && <Card className="p-6 mb-4"><Empty icon={GitBranch} title="No contacts to organize" hint="Add contacts to see them flow through your pipeline stages." /></Card>}
      <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-thin">
        {stages.map((s) => {
          const items = contacts.filter((c) => (c.stage || stages[0]?.name) === s.name);
          return (
            <div key={s.id} className="w-72 shrink-0" onDragOver={(e) => e.preventDefault()} onDrop={() => onDrop(s.name)} data-testid={`pipeline-stage-${s.name.replace(/\s+/g,'-').toLowerCase()}`}>
              <div className="flex items-center justify-between mb-3 px-1">
                <h3 className="font-display font-bold text-slate-800 text-sm">{s.name}</h3>
                <span className="text-xs font-semibold text-slate-400 bg-slate-100 px-2 py-0.5 rounded-full">{items.length}</span>
              </div>
              <div className="space-y-2 min-h-[120px] bg-slate-100/60 rounded-lg p-2">
                {items.map((c) => (
                  <Card key={c.id} draggable onDragStart={() => setDrag(c)} className="p-3 cursor-grab active:cursor-grabbing" data-testid={`pipeline-card-${c.id}`}>
                    <Link to={`/app/contacts/${c.id}`} className="font-semibold text-slate-900 text-sm hover:text-alto-red">{c.first_name} {c.last_name}</Link>
                    <p className="text-xs text-slate-500 mt-0.5">{c.latest_source || "—"}</p>
                  </Card>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
